"use strict";

export var LoginFormConstants = {
  VALIDATE: 'VALIDATE',
  DO_LOGIN: 'DO_LOGIN',
  DO_LOGOUT: 'DO_LOGOUT'
};